import { ChangeEvent, FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UserSelectSearchRequest } from 'api/searchRequest/UserSelectSearchRequest';

type UserSelectSearchBoxProps = {
  searchRequest: UserSelectSearchRequest;
  onSubmit: (req: UserSelectSearchRequest) => void;
};

export default function UserSelectSearchBox({
  searchRequest,
  onSubmit,
}: UserSelectSearchBoxProps) {
  const { t } = useTranslation();

  const [key, setKey] = useState('');

  const onChangeKey = (event: ChangeEvent<HTMLInputElement>) => {
    setKey(event.target.value);
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    onSubmit({ ...searchRequest, searchKey: key });
  };

  return (
    <form>
      <div className={'filter-wrap'}>
        <div className={'filter'}>
          <dl>
            <dt>{t('communication.userName')}</dt>
            <dd>
              <input type={'text'} value={key} onChange={onChangeKey} />
            </dd>
          </dl>
        </div>
        <button
          type={'submit'}
          className={'black_white_btn btn_search'}
          onClick={handleSubmit}
        >
          {t('button.search')}
        </button>
      </div>
    </form>
  );
}
